<template>
  <section
    class="content"
    v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD, USER_ROLES.JOURNEY_MANAGER]"
  >
    <div>
      <div class="box-body">
        <div
          :class="addButtonClass"
          v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD]"
        >
        </div>
        <v-server-table
          ref="expiringLicenseTable"
          url
          :columns="columns"
          :options="options"
          v-on:row-click="edit"
          @loaded="onLoaded"
        >
          <template slot="beforeBody">
            <tr v-if="loading" class="VueTables__no-results">
              <td class="text-center" colspan="6">
                <pulse-loader></pulse-loader>
              </td>
            </tr>
          </template>
        </v-server-table>
      </div>
    </div>
  </section>
</template>

<script>
import { USER_ROLES } from '../../../config';
import { Event } from 'vue-tables-2';

import moment from 'moment';
export default {
  name: 'ExpiringLicense',
  data() {
    return {
      USER_ROLES: USER_ROLES,
      loading: null,
      expiringLicenseTable: null,
      columns: [
        'driverName',
        'mobileNumber',
        'managerFullname',
        'languageKnown',
        'lisenceNumber',
        'status',
        'licenseExpiryDate'
      ],

      options: {
        highlightMatches: true,
        sortable: [
          'driverName',
          'mobileNumber',
          'managerFirstName',
          'languageKnown',
          'lisenceNumber',
          'status',
          'licenseExpiryDate'
        ],

        headings: {
          driverName: 'Name',
          mobileNumber: 'Contact',
          manager: 'Manager',
          languageKnown: 'Language',
          lisenceNumber: 'License',
          status: 'Status',
          managerFullname: 'Manager',
          licenseExpiryDate: "License Expired On"
        },
        templates: {
          managerFullname(row, query) {
            return `${query.managerFirstName} ${query.managerLastName}`;
          },

          status(row, query) {
            return query.status[0].toUpperCase() + query.status.slice(1);
          },
          licenseExpiryDate(row,query){
              return moment(query.licenseExpiryDate).format('DD-MM-YYYY')
          }
        },

        requestFunction: request => {
          const params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          if (request.orderBy) {
            params.$sort = request.ascending
              ? '-' + request.orderBy
              : request.orderBy;
          } else {
            params.$sort = 'createdAt';
          }
          if (request.query) {
            params.$term = request.query;
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          this.loading = true;
          return this.$expiringLicenseDataRepository.list(params).catch(error => {
            console.error('driver.requestFunction-error:', error);
            this.$snotify.error('Get Driver', 'Error!');
          });
        },
        responseAdapter: response => {
          this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.docs.length,
          };
        },
        uniqueKey: '_id',
      },
    };
  },
  computed: {
    addButtonClass() {
      if (this.expiringLicenseTable) {
        return this.expiringLicenseTable.count > this.expiringLicenseTable.limit ||
          this.expiringLicenseTable.limit > 10
      } 
    },
  },
  methods: {
    edit(data) {
      this.$router.push({
        name: 'DriverDetail',
        params: {
          _id: data.row._id,
        },
        props: data.row,
      });
    },
    onLoaded() {
      this.expiringLicenseTable = this.$refs.expiringLicenseTable;
    },
    // getSelected(event) {
    // 	this.selectedStatus = event.target.value;
    // 	Event.$emit('vue-tables.filter', 'alphabet');
    // 	//this.$refs.deviceTable.setFilter({'status': event.target.value})
    // }
  },
};
</script>

<style scoped>
.sorting {
  position: absolute;
  left: 319px;
  z-index: 1000;
  width: 200px;
}
.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
}

</style>



// WEBPACK FOOTER //
// ExpiringLicense.vue?37c30ed0